import skeleton from '../../assets/skeleton.png';

import '../../styles/days.scss';

const Seven = () => (
  <div className='days full-image rounded'>
    <img src={skeleton} alt='preview' />
  </div>
);

export default Seven;
